import { render, staticRenderFns } from "./CompanyInfoImage.vue?vue&type=template&id=2bc7745f&scoped=true&"
import script from "./CompanyInfoImage.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoImage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoImage.vue?vue&type=style&index=0&id=2bc7745f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7745f",
  null
  
)

export default component.exports